import React, { useEffect, useMemo, useState } from 'react';
import RTOService from 'src/services/RTO.service';
import BrandAutocomplete, { createOption, createOptionsFromArr } from '.';

// TODO: data will come from api
function StateAutoComplete({
  onChange,
  value,
  name,
  label,
  required = false,
  ...rest
}) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    (async () => {
      const { data } = await RTOService.get();
      const newOptions = [];
      Object.keys(data)?.forEach((key) => {
        newOptions.push({ label: data[key]?.name, value: key });
      });
      setOptions(newOptions);
    })();
  }, []);

  return (
    <BrandAutocomplete
      label={label}
      placeholder="Select State"
      onChange={onChange}
      required={required}
      value={value}
      name={name ?? 'state'}
      options={createOptionsFromArr(options, 'label', 'value')}
      {...rest}
    />
  );
}

export default StateAutoComplete;
